var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('SaveWarning')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }